// Shared palette for recharts. CSS variables don't reach SVG fills directly,
// so we use brand-anchored hex values that read well on both dark and light themes.
export const chartPalette = {
  teal:     '#53C6C8',
  tealDeep: '#1B7577',
  navy:     '#0D1A26',
  ok:       '#10B981',
  warn:     '#F59E0B',
  err:      '#EF4444',
  info:     '#3B82F6',
  purple:   '#8B5CF6',
  pink:     '#EC4899',
  cream:    '#FDF6EC',
  textMid:  '#8BA4BC', // works in both themes
  grid:     'rgba(83, 198, 200, 0.18)',
};

// Tooltip styles — use elevated card token at runtime via inline styles.
export const tooltipContentStyle = {
  background: 'var(--bg-elevated)',
  border: '1px solid var(--bd-strong)',
  borderRadius: 10,
  color: 'var(--tx1)',
  fontSize: 12,
  fontFamily: 'var(--font)',
  padding: '8px 10px',
  boxShadow: '0 12px 28px rgba(0,0,0,0.32)',
};

export const corridorPalette = {
  CAD_KES: chartPalette.teal,
  CAD_NGN: chartPalette.warn,
  CAD_GHS: chartPalette.purple,
  CAD_ZAR: chartPalette.err,
  CAD_UGX: chartPalette.info,
  CAD_TZS: chartPalette.pink,
};

export const networkPalette = {
  base:    chartPalette.teal,
  polygon: chartPalette.purple,
  solana:  chartPalette.warn,
};
